import TransactionDetailsOrder from "../../../entities/checkout/transaction/TransactionDetailsOrder";
import { ITransactionDetailsOrder } from "../../../entities/checkout/transaction/types";
import { IManhattanFactory } from "../../manhattan/types";

export const TransactionDetailsOrderFactory: IManhattanFactory = class TransactionDetailsOrderFactory {

  static create(transactionDetailsOrder: ITransactionDetailsOrder | null) {
    if (transactionDetailsOrder) {
      const date = new Date(transactionDetailsOrder.finishedAt);
      const  formatDate = date.toLocaleDateString("sr-YU", { // you can skip the first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return new TransactionDetailsOrder(
        transactionDetailsOrder.status,
        transactionDetailsOrder.secret,
        transactionDetailsOrder.referenceId,
        transactionDetailsOrder.type ? transactionDetailsOrder.type : "",
        transactionDetailsOrder.finishedAt,
        formatDate,
        `${date.getHours()  }:${  date.getMinutes()  }`
      );
    }
    return null;
  }

};
